


let CopyLinks = [].slice.call( document.querySelectorAll( '[data-copylink]' ) );

function Constructor() {

    CopyLinks.forEach( button => {
        if ( ! button.classList.contains( 'generated' ) ) {
            button.addEventListener( 'click', onClickCopy );
            button.classList.add( 'generated' );
        }
    });
}

function onClickCopy( event ) {
    event.preventDefault();
    
    const button  = this;
    const input   = document.createElement( "input" );
    const inputID = "temp_"+(new Date().getTime());
    let URL     = button.dataset.copylink;
    
    URL = URL != '' ? URL : window.location.href;
    
    
    input.id       = inputID;
    input.value    = URL;
    input.readonly = true;
    
    input.style.position = 'fixed';
    input.style.top = '0';
    input.style.left = '0';
    input.style.opacity = '0';
    input.style.fontSize = '16px';
    
    document.body.appendChild( input );
    
    
    if ( navigator.userAgent.match(/ipad|ipod|iphone/i) ) {
        var el       = document.querySelector( "#"+inputID );
        var editable = el.contentEditable;
        var readOnly = el.readOnly;
        
        el.contentEditable = true;
        el.readOnly        = false;
        
        var range = document.createRange();
        range.selectNodeContents(el);
        
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange( range );
        el.setSelectionRange( 0, 999999 );
        el.contentEditable = editable;
        el.readOnly        = readOnly;
    } else {
        input.select();
    }
    
    document.execCommand( 'copy' );
    
    this.classList.add( 'active' );

    setTimeout(function(){
        document.body.removeChild( input );
        button.classList.remove( 'active' );
    }, 3000);
}


export default Constructor;